export const MEMED_SIGNATURE_PROVIDERS: string[] = [
  'certisign',
  'evaltec',
  'lacuna',
  'soluti',
  'dinamo',
  'vidaas',
  'safeid',
];

export const MEMED_FEATURE_TOGGLE_DEFAULTS: Record<string, boolean> = {
  // Matriz Restritiva de Governança e Compliance Medikei
  forceSign: true,
  editIdentification: false,
  deletePatient: false,
  removePatient: false,
  editPatient: false,
  dropdownSync: false,
  allowShareModal: false,
  conclusionModalEdit: false,
  copyMedicalRecords: true,
  historyPrescription: false,
  setAllowedSignatureProviders: true,
  buttonClose: true,
  setPatientAllergy: true,
  optionsPrescription: true,
  removePrescription: true,
  autocompleteManipulated: true,
  autocompleteCompositions: true,
  autocompletePheripherals: true,
  newFormula: true,
  guidesOnboarding: false,
  showProtocol: true,
  showHelpMenu: true,
  addPrescriptionDrug: true,
  removePrescriptionDrug: true,
  editPrescriptionDrugTitle: true,
  editPosology: true,
  editQuantity: true,
  enableAlerts: true,
};

const KNOWN_TOGGLE_KEYS = new Set(Object.keys(MEMED_FEATURE_TOGGLE_DEFAULTS));

export function buildFeatureTogglePayload(
  configured?: Record<string, boolean | string[]>
): Record<string, boolean | string[]> {
  if (!configured) {
    return {};
  }

  const payload: Record<string, boolean | string[]> = {};

  for (const [key, value] of Object.entries(configured)) {
    if (!KNOWN_TOGGLE_KEYS.has(key)) {
      continue;
    }

    if (key === 'setAllowedSignatureProviders') {
      if (Array.isArray(value)) {
        const providers = value.filter((provider): provider is string =>
          typeof provider === 'string' && MEMED_SIGNATURE_PROVIDERS.includes(provider)
        );
        if (providers.length > 0) {
          payload[key] = providers;
        }
      }
      continue;
    }

    if (typeof value === 'boolean' && value !== MEMED_FEATURE_TOGGLE_DEFAULTS[key]) {
      payload[key] = value;
    }
  }

  return payload;
}
